<div mat-dialog-content>
  <p>
    Êtes-vous sûr de vouloir transmettre cette commande ?
  </p>
  <p *ngIf="!canEditSend">
    Après confirmation, elle ne sera plus modifiable.
  </p>
  <p *ngIf="canEditSend">
    Après confirmation, la commande déjà transmise sera mise à jour avec les nouvelles données.
  </p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="refuse()" color="white">Annuler</button>
  <button mat-raised-button color="primary" (click)="submitAndSend()" [disabled]="isSending">Confirmer</button>
</div>